import {
  GET_LINKED_ACCOUNTS,
  GET_MY_PROFILE,
  LOGIN_STATUS
} from './graphql/accounts.graphql'
import client from '../client/ApolloAccountsBffClient'

export default class AccountsBffClientHttp {  
  async getLinkedAccounts(){
    try {
      const res = await client.query({
        query: GET_LINKED_ACCOUNTS,
      })

      return {
        data: {
            linkedAccounts: res.data.linkedAccounts,
            success: true,
        },
      }
    } catch (e) {
      return {
        data: {
            linkedAccounts: [],
            success: false,
        },
      }
    }
  }

  async getMyProfile() {
    try {
      const res = await client.query({
        query: GET_MY_PROFILE,
        fetchPolicy: 'no-cache',
      })

      return {
        data: {
          profile: {
            ...res.data.profileNewModel,
            success: true,
          },
        },
      }
    } catch (e) {
      return {
        data: {
          profile: {
            success: false,
          },
        },
      }
    }
  }

  async loginStatus() {
    try {
      const { data } = await client.query({
        query: LOGIN_STATUS,
        fetchPolicy: 'no-cache',
      })
      
      if (data && data.loginStatus){
        return data.loginStatus
      }

      return {
        loggedIn: false,
      }
    } catch (e) {
      return {
        loggedIn: false,
      }
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/shared/api/http/AccountsBffClientHttp.js